import React from 'react';

function SponsorPage(props) {
	return (
		<div>
			<div className="generic-page container">
				<div className="generic-page" style={{textAlign:"center"}}>
					<div className="row m-0 p-0">
						<img className="col-lg-6 col-12" src="/img/backoffice_landing_page.png" alt="Logo"  style={{ height: "300px", objectFit: "contain" }}></img>
						<img className="col-lg-6 col-12" src="/img/backoffice_landing_page_1.png" alt="Logo"  style={{ height: "300px", objectFit: "contain" }}></img>
					</div>

				</div>
			</div>
		</div>
	)
}

export default SponsorPage;